<template>
  <div style="width: 100%;height: 100%;">
    <div class="tt-input" style="display: flex;align-items: center;height:56px;width: calc(100% - 5px);background-color: #FFFFFF;text-align:left;line-height: 56px;padding-left:5px">
      起止日期：
      <el-date-picker  v-model="startDate" style="margin-left: 10px;width:150px"
                    placeholder="选择日期" value-format="yyyy-MM-dd"  :clearable="false"/>
      <span style="margin-right: 16px;">一</span>
      <el-date-picker  v-model="endDate" style="width:200px;margin-left: 2px;"
                     placeholder="选择日期"   :clearable="false" value-format="yyyy-MM-dd"/>
      <el-button style="margin-left:156px;width:100px;height:32px;padding-top: 8px;" @click="getCurveData" type="primary">查询</el-button>
    </div>
    <div style="width: 100%;height: 520px;">
      <common-charts :init-options="initOptions" :index="200" :key="timestamp" :options="chartData"
          autoresize style="margin-left: 5px;width: 740px;height: 500px;" />
    </div>
  </div>
</template>

<script>
import CommonCharts from "../../common/chart/CommonCharts";
import buildCommonConfig from "../../../config/chart/config_extra_device_line";
export default {
  props: ['sensorId', 'dataId'],
  components: { CommonCharts },
  data() {
    return {
      startDate: new Date().Format('yyyy-MM-dd'),
      endDate: new Date().Format('yyyy-MM-dd'),
      unit: '',
      initOptions: {
        renderer: 'canvas'
      },
      timestamp: 0
    }
  },
  created() {
    this.getCurveData()
  },
  methods: {
    getCurveData() {
      let params = {'id': this.sensorId, 'startDate': this.startDate, 'endDate': this.endDate, 'dataId': this.dataId}
      this.$api.extraDevice.getCurveDataById(params).then(res => {
        let xAxis = res.data.dataTime
        let data = []
        res.data.curveList.forEach((sd) => {
          data.push({
            name: '',
            type: 'line',
            data: sd.dataData.split(","),
            markPoint: {
              data: [
                {type: 'max', name: '最大值'},
                {type: 'min', name: '最小值'}
              ]
            },
            markLine: {
              data: [
                {type: 'average', name: '平均值'}
              ]
            }
          })
        })
        this.chartData = buildCommonConfig(xAxis, data, 'dataMin', this.unit)
        this.timestamp = new Date().getTime()
      })
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/EnergyEfficiency/ExtraDevice/CurveDialog.vue